import { render, staticRenderFns } from "./DocumentDeleteCardButton.vue?vue&type=template&id=65be59f5&scoped=true"
import script from "./DocumentDeleteCardButton.vue?vue&type=script&lang=js"
export * from "./DocumentDeleteCardButton.vue?vue&type=script&lang=js"
import style0 from "./DocumentDeleteCardButton.vue?vue&type=style&index=0&id=65be59f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65be59f5",
  null
  
)

export default component.exports